<template>
  <div class="container">
    <section>
      <div class="container is-vcentered">
        <div class="columns is-centered mt-10">
          <div class="column is-10">
            <span class="title has-text-grey has-text-centered">
              <router-link to="/">
                <img
                  class
                  src="~/../assets/images/logos/brand-logo.png"
                  width="50%"
                  alt
                />
              </router-link>
              <hr />
              <h4 class="title is-3 has-text-centered mb-20">
                هذا الموقع تحت الصيانة، الرجاء المحاولة لاحقاً
              </h4>
              <!-- <hr> -->
            </span>

            <hr />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "maintenance",
};
</script>
